import { combineReducers } from 'redux';
import app from './app';
import damage_report from './damage_report';

export default combineReducers({
  app,
  damage_report
});
